<template>
  <header>
    <AlertBar
      v-if="alerts"
      v-for="(alert, key) in alerts"
      :key="key"
      :data="alert"></AlertBar>
    <Nav :currentUrl="$page.url" />
  </header>
  <main>
    <slot />
  </main>
  <Footer />
</template>

<script>
import Nav from "../Components/Nav/Nav.vue";
import Footer from "../Components/Footer.vue";

export default {
  components: {
    Footer,
    Nav,
  },

  props: {
    alerts: {
      type: Object,
      required: false,
    },
  },
};
</script>
